var React = require('react');

function IndicatorIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"nonzero","d":"M2.703 6.67L0 9.543 7.198 16 19 2.535 15.965 0 6.854 10.395z"}));
}

IndicatorIcon.defaultProps = {"width":"19","height":"16","viewBox":"0 0 19 16"};

module.exports = IndicatorIcon;

IndicatorIcon.default = IndicatorIcon;
